import classnames from "classnames";
import React from "react";
import styles from "./logotype-checkbox.css";

export interface Brand {
    name: string;
    checked: boolean;
    image_url: string;
    slug: string;
}
interface LogotypeCheckboxProps extends Brand {
    onChange: () => void;
}

function LogotypeCheckbox({
    name,
    checked,
    image_url: imageUrl,
    onChange,
}: LogotypeCheckboxProps): JSX.Element {
    return (
        <div className={styles.wrapper}>
            <label className={classnames(styles.container, { [styles.checked]: checked })}>
                <img
                    className={classnames(styles.logotype, { [styles.checkedLogotype]: checked })}
                    src={imageUrl}
                    alt={name}
                />
                <span className={styles.checkboxContainer}>
                    <input onChange={onChange} type="checkbox" checked={checked} />
                    <span className={styles.checkmark}></span>
                </span>
                <span className={styles.label}>{name}</span>
            </label>
        </div>
    );
}

export default LogotypeCheckbox;
